import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as partnershipApi from '../../api/partnershipApi';

export const fetchPartnerships = createAsyncThunk(
  'partnership/fetch',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await partnershipApi.fetchPartnerships(params);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors du chargement.');
    }
  }
);

export const fetchPartnershipById = createAsyncThunk(
  'partnership/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      return await partnershipApi.fetchPartnershipById(id);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Partenariat introuvable.');
    }
  }
);

export const createPartnership = createAsyncThunk(
  'partnership/create',
  async (payload, { rejectWithValue }) => {
    try {
      return await partnershipApi.createPartnership(payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de la création.');
    }
  }
);

export const updatePartnership = createAsyncThunk(
  'partnership/update',
  async ({ id, ...payload }, { rejectWithValue }) => {
    try {
      return await partnershipApi.updatePartnership(id, payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de la mise à jour.');
    }
  }
);

export const deletePartnership = createAsyncThunk(
  'partnership/delete',
  async (id, { rejectWithValue }) => {
    try {
      await partnershipApi.deletePartnership(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de la suppression.');
    }
  }
);

const partnershipSlice = createSlice({
  name: 'partnership',
  initialState: {
    list: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrent: (state) => {
      state.current = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartnerships.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartnerships.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchPartnerships.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPartnershipById.fulfilled, (state, action) => {
        state.current = action.payload;
      })
      .addCase(createPartnership.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPartnership.fulfilled, (state, action) => {
        state.loading = false;
        state.list = [action.payload, ...state.list];
      })
      .addCase(createPartnership.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePartnership.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePartnership.fulfilled, (state, action) => {
        state.loading = false;
        const i = state.list.findIndex((x) => x._id === action.payload._id);
        if (i >= 0) state.list[i] = action.payload;
        if (state.current?._id === action.payload._id) state.current = action.payload;
      })
      .addCase(updatePartnership.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deletePartnership.fulfilled, (state, action) => {
        state.list = state.list.filter((x) => x._id !== action.payload);
        if (state.current?._id === action.payload) state.current = null;
      });
  },
});

export const { clearCurrent, clearError } = partnershipSlice.actions;
export default partnershipSlice.reducer;
